import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import sanitizeEmailHtml from '../../../utils/sanitizeHtml';

interface Props {
  html: string | null | undefined;
  emptyText?: string;
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}

// Renders stored e-mail HTML as formatted markup after DOMPurify sanitization.
// Central place for the raw-HTML render so the sanitize step can never be
// forgotten at a call site (RITA-1307 stored-XSS hardening).
function SanitizedHtmlBox({ html, emptyText = 'Keine Vorlage verfügbar', sx, ...rest }: Props) {
  const clean = sanitizeEmailHtml(html);
  const markup = clean || `<em>${emptyText}</em>`;
  return (
    <Box
      data-testid={rest['data-testid']}
      sx={sx}
      // eslint-disable-next-line react/no-danger -- markup passes through sanitizeEmailHtml (DOMPurify) above.
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}

export default SanitizedHtmlBox;
